import App from './App.svelte'
import '../node_modules/bulma/css/bulma.min.css'

const app = new App({
  target: document.body,
  props: {},
})

export default app
